<template>
  <div class="navbar-fixed-content" style="padding-top:70px;">
    <my-account-header></my-account-header>

    <div class="myinfo-bottom">
      <div class="cnt">
        <my-side-menu></my-side-menu>
        <div class="myinfo-con">
          <div class="tabbable-line">
            <ul class="nav nav-tabs">
              <li :class="[showMySetting?'active':'']" @click="showMySettingClicked()">
                <a class="a-tab" data-toggle="tab">基本信息</a>
              </li>
              <li :class="[showMySetting?'':'active']" @click="showMySettingClicked()">
                <a class="a-tab" data-toggle="tab">修改密码</a>
              </li>
            </ul>
            <div class="tab-content">
              <div :class="[showMySetting? 'tab-pane form active':'tab-pane form']" id="tab_1">
                <div class="form-horizontal">
                  <div class="form-body">
                    <el-form
                      :model="form"
                      :rules="accountSettingRules"
                      ref="settingForm"
                      label-width="100px"
                    >
                      <input
                        data-val="true"
                        data-val-required="UserType 字段是必需的。"
                        id="UserType"
                        name="UserType"
                        type="hidden"
                        v-model="form.userType"
                      />
                      <div class="form-group" style="height:100px">
                        <label class="control-label" for="HeadImage">头像</label>
                        <input
                          id="HeadImage"
                          name="HeadImage"
                          type="hidden"
                          v-model="form.headImage"
                        />
                        <div class="form-group-r form-group-c">
                          <div id="uploader-logo">
                            <div class="qq-uploader-selector qq-uploader" qq-drop-area-text>
                              <div
                                class="qq-upload-drop-area-selector qq-upload-drop-area"
                                qq-hide-dropzone
                                style="display: none;"
                              ></div>
                              <ul
                                class="qq-upload-list-selector qq-upload-list"
                                aria-live="polite"
                                aria-relevant="additions removals"
                              >
                                <li class="file-old">
                                  <img
                                    class="qq-thumbnail-selector mylogo"
                                    qq-max-size="200"
                                    qq-server-scale
                                    :src="form.headImage"
                                  />
                                </li>
                              </ul>
                              <div
                                style="display: inline-block;position:absolute; width: 360px; vertical-align: middle;margin-left: 5px;"
                              >
                                <span
                                  style="line-height: 35px;color: #999;"
                                >支持jpg、jpeg、png或bmp格式的图片，建议小于32K</span>
                                <div
                                  class="qq-upload-button-selector qq-upload-button"
                                  style="position: relative; top: 25px; border: 3px; line-height: 29px; overflow: hidden; direction: ltr;"
                                >
                                  <div>修改头像</div>
                                  <input
                                    qq-button-id="93a9c49d-64c4-4454-a424-23aa6b52824a"
                                    title="file input"
                                    type="file"
                                    name="qqfile"
                                    style="position: absolute; right: 0px; top: 0px; font-family: Arial; font-size: 118px; margin: 0px; padding: 0px; cursor: pointer; opacity: 0; height: 100%;"
                                    @change="changeHeadImage($event)"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <el-form-item label="用户名" prop="userName">
                        <el-input v-model="form.userName" :disabled="true"></el-input>
                      </el-form-item>
                      <el-form-item label="昵称" prop="nickname">
                        <el-row>
                          <el-input
                            v-model="form.nickname"
                            :disabled="!changeUserNickName"
                            style="width:40%"
                          ></el-input>
                          <el-button
                            type="danger"
                            style="margin-left:12px;background-color:#DC001C"
                            size="medium"
                            v-show="!changeUserNickName"
                            @click="changeUserNickNameClick(-1)"
                          >立即修改</el-button>
                          <el-button
                            type="danger"
                            style="margin-left:12px;background-color:#DC001C"
                            size="medium"
                            v-show="changeUserNickName"
                            @click="changeUserNickNameClick(1)"
                          >保存</el-button>
                          <el-button
                            type="danger"
                            style="margin-left:12px;background-color:#DC001C"
                            size="medium"
                            v-show="changeUserNickName"
                            @click="changeUserNickNameClick(0)"
                          >取消</el-button>
                        </el-row>
                      </el-form-item>
                      <el-form-item label="电子邮箱" prop="emailAddress">
                        <el-row>
                          <el-input
                            v-model="form.emailAddress"
                            :disabled="!showMyEmailSetting"
                            style="width:40%"
                          ></el-input>
                          <el-button
                            type="danger"
                            style="margin-left:12px;background-color:#DC001C"
                            size="medium"
                            v-show="!showMyEmailSetting"
                            @click="changeMyEmailClick(-1)"
                          >立即修改</el-button>
                          <el-button
                            type="danger"
                            style="margin-left:12px;background-color:#DC001C"
                            size="medium"
                            v-show="showMyEmailSetting"
                            @click="changeMyEmailClick(1)"
                          >保存</el-button>
                          <el-button
                            type="danger"
                            style="margin-left:12px;background-color:#DC001C"
                            size="medium"
                            v-show="showMyEmailSetting"
                            @click="changeMyEmailClick(0)"
                          >取消</el-button>
                        </el-row>
                      </el-form-item>
                      <el-form-item label="手机号码" prop="phoneNumber">
                        <el-input v-model="form.phoneNumber" :disabled="true"></el-input>
                      </el-form-item>
                      <el-form-item label="姓名" prop="name">
                        <el-input v-model="form.name" :disabled="true"></el-input>
                      </el-form-item>
                      <el-form-item label="所属团队" prop="team">
                        <el-input v-model="form.team" :disabled="true"></el-input>
                      </el-form-item>
                      <el-form-item label="单位" prop="schoolname">
                        <el-input v-model="form.schoolname" :disabled="true"></el-input>
                      </el-form-item>
                      <el-form-item label="院系及专业" prop="specialty">
                        <el-input v-model="form.specialty" :disabled="true"></el-input>
                      </el-form-item>
                      <el-form-item label="职称" prop="positional">
                        <el-input v-model="form.positional"></el-input>
                      </el-form-item>
                      <el-form-item label="职务" prop="duty">
                        <el-input v-model="form.duty"></el-input>
                      </el-form-item>
                      <el-row>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-dark">
                            <el-form-item label="省份" prop="province">
                              <el-input v-model="form.province"></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-dark">
                            <el-form-item label="城市" prop="city">
                              <el-input v-model="form.city"></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>

                      <el-form-item label="性别">
                        <el-select
                          v-model="form.sex"
                          placeholder="请选择性别"
                          @change="chooseSexSelected($event)"
                        >
                          <el-option label="男" value="0"></el-option>
                          <el-option label="女" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="个人介绍">
                        <el-input type="textarea" v-model="form.introduction"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <button type="button" class="btn btn-default" @click="updateMyUserInfo()">保存</button>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
              <div :class="[showMySetting? 'tab-pane form':'tab-pane form active']" id="tab_2">
                <div class="form-horizontal">
                  <div class="form-body">
                    <el-form
                      :model="passwordForm"
                      :rules="passwordRules"
                      ref="passwordForm"
                      label-width="100px"
                    >
                      <el-form-item label="旧密码" prop="OldPassword">
                        <el-input type="password" v-model="passwordForm.OldPassword"></el-input>
                      </el-form-item>
                      <el-form-item label="新密码" prop="NewPassword">
                        <el-input type="password" v-model="passwordForm.NewPassword"></el-input>
                      </el-form-item>
                      <el-form-item label="确认新密码" prop="ConfirmPassword">
                        <el-input type="password" v-model="passwordForm.ConfirmPassword"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <button
                          type="button"
                          class="btn btn-default"
                          @click="changeMyNewPassword()"
                        >确认</button>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyAccountHeader from "@/layout/MyAccountHeader";
import MySideMenu from "@/layout/MySideMenu";
import comFun from "@/common/common";

let Base64 = require("js-base64").Base64;

export default {
  components: {
    MyAccountHeader,
    MySideMenu,
  },
  data() {
    var validateConPass2 = (rule, value, callback) => {
      if (value !== this.passwordForm.NewPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    return {
      form: {
        headImage: "",
        nickname: "",
        userName: "",
        emailAddress: "",
        phoneNumber: "",
        name: "",
        team: "",
        schoolname: "",
        specialty: "",
        positional: "",
        duty: "",
        province: "",
        city: "",
        sex: "0",
        introduction: "",
        training: "",
        userId: "",
        userType: null,
        id: "",
      },
      oldForm: {
        headImage: "",
        nickname: "",
        userName: "",
        emailAddress: "",
        phoneNumber: "",
        name: "",
        team: "",
        schoolname: "",
        specialty: "",
        positional: "",
        duty: "",
        province: "",
        city: "",
        sex: "0",
        introduction: "",
        training: "",
        userId: "",
        userType: null,
        id: "",
      },

      passwordRules: {
        OldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { required: true, message: "原密码输入错误", trigger: "change" },
          { min: 6, max: 30, message: "密码长度限制6~30位", trigger: "blur" },
        ],
        NewPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 30, message: "密码长度限制6~30位", trigger: "blur" },
        ],
        ConfirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { min: 6, max: 30, message: "密码长度限制6~30位", trigger: "blur" },
          { validator: validateConPass2, trigger: "blur" },
        ],
      },
      accountSettingRules: {
        nickname: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        emailAddress: [{ validator: checkEmail, trigger: "blur" }],

        positional: [
          { required: true, message: "请输入职称", trigger: "blur" },
        ],
        duty: [{ required: true, message: "请输入职务", trigger: "blur" }],
        province: [{ required: true, message: "请输入省份", trigger: "blur" }],
        city: [{ required: true, message: "请输入城市", trigger: "blur" }],
      },
      user: {},
      userAnalysis: {},
      userExpand: {},
      showMySetting: true,
      showMyEmailSetting: false,
      passwordForm: {
        OldPassword: "",
        NewPassword: "",
        ConfirmPassword: "",
      },

      changeUserNickName: false,
      coverImg: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },
  mounted() {
    this.getCurrentuserInfo();
  },
  methods: {
    // 获取全部
    getCurrentuserInfo: function () {
      comFun.getUserInfo().then((res) => {
        let dd = JSON.parse(Base64.decode(res));
        console.log(dd);
        this.form.headImage = dd.headImage;
        this.form.userName = dd.userName;
        this.form.nickname = dd.nickName;
        this.form.emailAddress = dd.emailAddress;
        this.form.phoneNumber = dd.phoneNumber;
        this.form.name = dd.name;
        this.form.team = dd.team;
        this.form.schoolname = dd.schoolName;
        this.form.specialty = dd.specialty;
        this.form.positional = dd.positional;
        this.form.duty = dd.duty;
        this.form.province = dd.province;
        this.form.city = dd.city;
        if(dd.sex){
          this.form.sex = dd.sex + "";
        }
        
        this.form.introduction = dd.introduction;
        this.form.training = dd.training;
        this.form.userId = dd.userId;
        this.form.userType = dd.userType;
        this.form.id = dd.id;

        // this.oldForm = this.form;
        this.oldForm.headImage = dd.headImage;
        this.oldForm.userName = dd.userName;
        this.oldForm.nickname = dd.nickName;
        this.oldForm.emailAddress = dd.emailAddress;
        this.oldForm.phoneNumber = dd.userName;
        this.oldForm.name = dd.name;
        this.oldForm.team = dd.team;
        this.oldForm.schoolname = dd.schoolName;
        this.oldForm.specialty = dd.specialty;
        this.oldForm.positional = dd.positional;
        this.oldForm.duty = dd.duty;
        this.oldForm.province = dd.province;
        this.oldForm.city = dd.city;
        if(dd.sex){
          this.oldForm.sex = dd.sex + "";
        }
        this.oldForm.introduction = dd.introduction;
        this.oldForm.training = dd.training;
        this.oldForm.userId = dd.userId;
        this.oldForm.userType = dd.userType;
        this.oldForm.id = dd.id;
      });
    },

    showMySettingClicked() {
      this.showMySetting = !this.showMySetting;
    },
    changeMyNewPassword: function () {
      this.$refs["passwordForm"].validate((valid) => {
        if (valid) {
          comFun.updateUserPassword(this.passwordForm).then((res) => {
            if (res.success) {
              var msg = {
                type: "success",
                text: "修改成功！",
              };
              this.$store.dispatch("setMsg", msg);
            } else {
              var msg = {
                type: "error",
                text: res.error.message,
              };
              this.$store.dispatch("setMsg", msg);
              this.passwordForm.OldPassword = "";
            }
          });
        }
      });
    },

    changeHeadImage(e) {
      var file = e.target.files[0];
      var that = this;
      let fd = new FormData();
      fd.append("qqfile", file);
      comFun.uploadImageFile(fd).then((res) => {
        if (res.success == true) {
          that.form.headImage = res.result.fileUrl;
        }
      });
    },
    changeUserNickNameClick(t) {
      if (t == -1) {
        this.changeUserNickName = !this.changeUserNickName;
      } else if (t == 1) {
        if (this.form.nickname) {
          comFun.upadteUserNickName(this.form.nickname).then((res) => {
            if (!res.success) {
              this.userInfo.nickname = this.form.nickname;
              t = 0;
            }
            this.loadMessageShow(t);
          });
          this.changeUserNickName = !this.changeUserNickName;
        } else {
          var msg = {
            type: "error",
            text: res.error.message,
          };
          this.$store.dispatch("setMsg", msg);
        }
      } else if (t == 0) {
        this.form.nickname = this.oldForm.nickname;
        this.$refs["settingForm"].validate((valid) => {
          if (valid) {
          }
        });
        this.changeUserNickName = !this.changeUserNickName;
      }
    },
    changeMyEmailClick(t) {
      if (t == -1) {
        this.showMyEmailSetting = !this.showMyEmailSetting;
      } else if (t == 1) {
        this.$refs["settingForm"].validate((valid) => {
          if (valid) {
            comFun
              .updateUserEmailAddress(this.form.emailAddress)
              .then((res) => {
                if (!res.success) {
                  this.userInfo.emailAddress = this.form.emailAddress;
                  t = 0;
                }
                this.loadMessageShow(t);
              });
            this.showMyEmailSetting = !this.showMyEmailSetting;
          } else {
            var msg = {
              type: "error",
              text: "格式错误！",
            };
            this.$store.dispatch("setMsg", msg);
          }
        });
      } else if (t == 0) {
        this.form.emailAddress = this.oldForm.emailAddress;
        this.$refs["settingForm"].validate((valid) => {
          if (valid) {
          }
        });
        this.showMyEmailSetting = !this.showMyEmailSetting;
      }
    },
    chooseSexSelected(e) {
      this.form.sex = e;
    },
    updateMyUserInfo() {
      this.$refs["settingForm"].validate((valid) => {
        if (valid) {
          comFun.updateUserInfo(this.form).then((res) => {
            if (res.success) {
              var msg = {
                type: "success",
                text: "修改成功！",
              };
              this.$store.dispatch("setMsg", msg);
              this.$router.go(0);
            } else {
              var msg = {
                type: "error",
                text: res.error.message,
              };
              this.$store.dispatch("setMsg", msg);
            }
          });
        }
      });
    },
    loadMessageShow(t) {
      if (t == 0) {
        var msg = {
          type: "error",
          text: "修改失败！",
        };
        this.$store.dispatch("setMsg", msg);
      } else {
        var msg = {
          type: "success",
          text: "修改成功！",
        };
        this.$store.dispatch("setMsg", msg);
      }
    },
    alertMessageShow(text) {
      var msg = {
        type: "error",
        text: text,
      };
      this.$store.dispatch("setMsg", msg);
    },
  },
};
</script>
<style scoped>
.qq-upload-list-selector {
  width: 100px;
  display: inline-block;
}

.mylogo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.qq-upload-button-selector {
  width: 100px;
  height: 38px;
  text-align: center;
  line-height: 25px;
  background: #e51c23;
  color: white;
  font-size: 16px;
  border-radius: 2px;
}

.qq-upload-button:hover {
  background: #d01716;
}

.edit-email {
  line-height: 25px;
  background: #e51c23;
  height: 25px;
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
  color: white;
  border-radius: 3px;
}

.edit-email:hover {
  background: #d01716;
  color: white;
}

.edit-nickname {
  line-height: 25px;
  background: #e51c23;
  height: 25px;
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
  color: white;
  border-radius: 3px;
}

.edit-nickname:hover {
  background: #d01716;
  color: white;
}

.myinfo-bottom .btn:hover {
  background: #d01716;
  color: #fff;
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #dddddb;

  color: #888;
}
</style>
